<template>
  <v-card>
    <v-card-title style="align-items: left">{{ $t("reject_reason") }}</v-card-title>
    <v-row>
      <v-col style="padding-bottom: 0">
        <v-textarea
          v-model="rejectionReason"
          :auto-grow="true"
          :autofocus="true"
          :rules="[isReasonValid || '']"
          class="px-4 text-wrap"
          color="#E95532"
          outlined
          style="margin-bottom: -12px; word-wrap: break-word"
          width="250"
        />
      </v-col>
      <v-col style="padding-bottom: 0; text-align: center">
        <v-btn :disabled="!isReasonValid" color="#fc461c" outlined width="250" @click="reject()">
          {{ $t("send") }}
        </v-btn>
      </v-col>
      <v-col style="text-align: center">
        <v-btn color="#fc461c" text width="250" @click="cancel()">
          {{ isMBS ? $t("back") : $t("cancel") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { computed, createComponent, value } from "vue-function-api";
import store from "@/store";
import { i18n } from "@/framework/plugins/i18n";
import { ConversationMutation } from "@/framework/store/conversation/types";
import { AccessLogRepository, LogAction } from "@/framework/logger/accessLog/accessLogRepository";
import { InquiryService } from "@/framework/api/Staff/ChatService/InquiryService";
import { ErrorService } from "@/framework/errors/ErrorService";

export default createComponent({
  setup(props, context) {
    const $route = context.root.$route;
    const $router = context.root.$router;

    const currentLangCd = value(i18n.locale);

    const isMBS = true;

    const rejectionReason = value("");
    const isReasonValid = computed(() => rejectionReason && rejectionReason.value != "");

    const reject = async () => {
      if ($route.params.conversationId) {
        console.warn("Rejecting inquiry");

        try {
          // create the rejection
          const rejectresult = await new InquiryService().rejectTheInquiry(
            $route.params.conversationId,
            currentLangCd.value,
            rejectionReason.value
          );
          if (rejectresult.isErr()) {
            await new ErrorService().handleError(rejectresult.error);
          }
          // drop the importance so it won't show in the queue/gets proper styling
          store.commit(ConversationMutation.SET_IMPORTANCE, "");
          // redirect to the main conversations screen
          $router.push({ path: `/${currentLangCd.value}/conversations` });
        } catch (error) {
          console.log("Error rejecting inquiry: " + error);
          //keeping the same behavior as normal completion, as no decision was made on how to handle errors
          $router.push({ path: `/${currentLangCd.value}/conversations` });
        }
        void new AccessLogRepository().sendFePWAStaffLog(LogAction.CompleteQuery, {
          conversation_id: $route.params.conversationId,
        });
      }
    };

    const cancel = () => {
      context.emit("handleCancel");
    };

    return {
      props,
      isMBS,
      rejectionReason,
      isReasonValid,
      reject,
      cancel,
    };
  },
});
</script>

<style lang="scss" scoped></style>
